export default __webpack_public_path__ + "static/media/steering-wheel 1.c06f4c66.svg";